import { apiClient } from '@shared/api/client';

export interface ShareCertificateMemberRow {
  id: string;
  contactCd: string;
  contactName: string;
  name: string;
  contactRegNo?: string;
  shareholderIdx?: number;
  shareCapitalIdx?: number | null;
  shareType?: string;
  numberOfShares?: number;
  currencyName?: string;
  positionName?: string;
}

export interface ShareCertificateEntityBasics {
  company_name: string;
  uen: string;
  registered_office_address: string;
}

export interface ShareCertificateSnapshot {
  company_name: string;
  uen: string;
  registered_office_address: string;
  member_name: string;
  cert_no: string;
  share_class: string;
  no_of_shares: string;
  issue_date: string;
  issue_date_iso?: string;
  contact_cd: string;
  shareholder_idx?: number;
  share_capital_idx?: number;
  currency_cd?: string;
  currency_name?: string;
}

export async function getShareCertificateEntitySnapshot(entityCd: string) {
  const response = await apiClient.get<ShareCertificateEntityBasics>(
    '/startTask/share-certificate/entity-snapshot',
    { params: { entityCd } },
  );
  const data = (response as any)?.data?.data ?? (response as any)?.data ?? response;
  return data as ShareCertificateEntityBasics;
}

export async function getShareCertificateMembers(entityCd: string) {
  const response = await apiClient.get<{ members?: ShareCertificateMemberRow[] }>(
    `/startTask/share-certificate/members/${encodeURIComponent(entityCd)}`,
  );
  const data = (response as any)?.data?.data ?? (response as any)?.data ?? response;
  return (data?.members || []) as ShareCertificateMemberRow[];
}

/** 증서(Certificate) 단위 목록 — 같은 주주가 증서를 여러 장 가지면 증서마다 1행(삭제 행 제외). */
export interface ShareCertificateCertRow {
  id: string;
  contactCd: string;
  contactName: string;
  name: string;
  contactRegNo?: string;
  categoryCd?: string;
  shareholderIdx: number | string;
  shareCapitalIdx?: number | string;
  certNo?: string;
  certLabel: string;
  positionName: string;
}
export async function getShareCertificateCertificates(entityCd: string) {
  const response = await apiClient.get<{ certificates?: ShareCertificateCertRow[] }>(
    `/startTask/share-certificate/certificates/${encodeURIComponent(entityCd)}`,
  );
  const data = (response as any)?.data?.data ?? (response as any)?.data ?? response;
  return (data?.certificates || []) as ShareCertificateCertRow[];
}

/** shareholderIdx 를 주면 그 증서, 없으면 그 주주의 증서 중 최신 1장. */
export async function getShareCertificateSnapshot(entityCd: string, contactCd: string, shareholderIdx?: number | string) {
  const params: Record<string, string> = { entityCd, contactCd };
  if (shareholderIdx != null && String(shareholderIdx).trim()) params.shareholderIdx = String(shareholderIdx);
  const response = await apiClient.get<ShareCertificateSnapshot>(
    '/startTask/share-certificate/snapshot',
    { params },
  );
  const data = (response as any)?.data?.data ?? (response as any)?.data ?? response;
  return data as ShareCertificateSnapshot;
}
